import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Sector } from '../shared/interfaces/sector.interface';

@Injectable({
  providedIn: 'root'
})
export class SectorService {

  constructor(private http: HttpClient) { }
  baseUrl = '@cec-api/sector';

  get():Promise<any>{
    return this.http.get(this.baseUrl).toPromise();
  }

  getById(id: number): Promise<any>{
    return this.http.get(this.baseUrl+'/'+id).toPromise();
  }

  addSector(user: Sector): Promise<any>{
    return this.http.post(this.baseUrl, user).toPromise();
  }

  updateSector(user: Sector, id: number): Promise<any>{
    return this.http.put(this.baseUrl+'/'+id, user).toPromise();
  }

  deleteSector(id:number){
    return this.http.delete(this.baseUrl+'/'+id).toPromise();
  }

  searchSector(searchValue: string):Promise<any>{
    return this.http.get('@cec-api/sector-search?name='+ searchValue).toPromise();
  }
}
